<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updateUserDataRecentPlayedQuestionsMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updateUserDataRecentPlayedQuestionsMutation = gql`
      mutation($id: ID!, $recentPlayedQuestions: JSON!, $totalPlayedQuestions: JSON!) {
        updateUserData(id: $id, data: { recentPlayedQuestions: $recentPlayedQuestions, totalPlayedQuestions: $totalPlayedQuestions }) {
          data {
            id
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updateUserDataRecentPlayedQuestions } = useMutation(updateUserDataRecentPlayedQuestionsMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updateUserDataRecentPlayedQuestions', result: updateUserDataRecentPlayedQuestions });
  },
};
</script>
